export const config = {
    appId: 'e424bd87-bce6-4ab3-a9d2-a6b4f0a896ed',
    redirectUri: `${window.location.origin}/login`,
    scopes: [
        'user.read',
        'Mail.Read'
    ],
    authority: `https://login.microsoftonline.com/inacatalog.com`,
}